import mapboxgl from 'mapbox-gl'

const STREETS_STYLE = 'mapbox://styles/mapbox/streets-v11'
const removedMaps = new WeakSet()

export function createMap ({ container, accessToken, center, zoom = 10 }) {
  if (!accessToken) throw new Error('A Mapbox access token is required')

  mapboxgl.accessToken = accessToken

  const map = new mapboxgl.Map({
    container,
    style: STREETS_STYLE,
    center,
    zoom
  })

  map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')
  map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: { enableHighAccuracy: true },
      trackUserLocation: true,
      showUserHeading: true
    }),
    'bottom-right'
  )

  return map
}

export function fitMapToCoordinates (
  map,
  coordinates,
  { defaultCenter, defaultZoom = 10, maxZoom = 14, padding = 60, duration = 0 } = {}
) {
  if (coordinates.length === 0) {
    map.easeTo({ center: defaultCenter, zoom: defaultZoom, duration })
    return
  }

  const bounds = new mapboxgl.LngLatBounds()
  coordinates.forEach((coordinate) => bounds.extend(coordinate))
  map.fitBounds(bounds, { padding, maxZoom, duration })
}

export function teardownMap (map) {
  if (!map || removedMaps.has(map)) return

  removedMaps.add(map)
  map.remove()
}
